import { NamespacedImageKeys } from "@betty/moonlight"

export const ProvidersMobile: NamespacedImageKeys[] = [
  'landingPage.gamesGlobalV2',
  'landingPage.lightAndWonderV2',
  'landingPage.pragmaticV2',
  'landingPage.igtV2',
  'landingPage.everiV2',
  'landingPage.playsonV2',
  'landingPage.blueprintV2',
  'landingPage.playngoV2',
  'landingPage.inspiredV2',
  'landingPage.hacksawV2',
  'landingPage.wazdanV2',
  'landingPage.backseatGamingV2',
  'landingPage.peterAndSonsV2',
  'landingPage.relaxV2',
  'landingPage.stakelogicV2',
  'landingPage.slingoV2',
  'landingPage.spinberryV2',
  'landingPage.bigTimeGamingV2',
  'landingPage.netentV2',
  'landingPage.redTigerV2',
  'landingPage.agsV2',
  'landingPage.fortheplayersV2',
  'landingPage.fantasmaGamesV2',
  'landingPage.blueGuruGamesV2',
  'landingPage.fourLeafGamingV2',
  'landingPage.reelPlayV2',
  'landingPage.noLimitCityV2',
  'landingPage.silverbackGamingV2',
  'landingPage.avataruxV2',
  'landingPage.goldenRockV2',
  'landingPage.stormGamingV2',
  'landingPage.trustyGamingV2',
  'landingPage.kitsuneStudioV2',
  'landingPage.jadeRabbitV2',
  'landingPage.nownowGamingV2',
  'landingPage.wizardV2',
]

export const ProvidersWeb: NamespacedImageKeys[] = [
  'landingPage.provider1',
  'landingPage.provider2',
  'landingPage.provider3',
  'landingPage.provider4',
  'landingPage.provider5',
  'landingPage.provider6',
  'landingPage.provider7',
  'landingPage.provider8',
  'landingPage.provider9',
  'landingPage.provider10',
  'landingPage.provider11',
  'landingPage.provider12',
  'landingPage.provider13',
  'landingPage.provider14',
  'landingPage.provider15',
  'landingPage.provider16',
  'landingPage.provider17',
  'landingPage.provider18',
]

